import { createAction, props } from '@ngrx/store';
import { CancelAssetServicesRequestV26 } from 'src/app/models-v26/wizards/cancel-license-services-request';
import { ActionResponse } from 'src/app/models/action-response';
import { TerminateMultiAssetDueDatesStepV26 } from 'src/app/shared-components-v26/allocation-wizard-modal-dialogs/terminate-multi-asset-wizard/init-step/due-date-step';
import { TerminateMultiAssetAssetStepV26 } from 'src/app/shared-components-v26/allocation-wizard-modal-dialogs/terminate-multi-asset-wizard/terminate-multi-asset-asset-step/terminate-multi-asset-asset-step-info';
import { TerminateMultiAssetCancelDetailsDataV26 } from 'src/app/shared-components-v26/allocation-wizard-modal-dialogs/terminate-multi-asset-wizard/terminate-multi-asset-cancel-details-step/terminate-multi-asset-cancel-details-data';

export const selectAssetStep = createAction(
  '[V26 Wizard Asset Step] Select Init Terminate Multi Asset Asset Step',
  props<{ assetStep: TerminateMultiAssetAssetStepV26 }>(),
);

export const selectDueDatesStep = createAction(
  '[V26 Catalog Page] Select DueDates Terminate Multi Asset Information Step',
  props<{ dueDatesStep: TerminateMultiAssetDueDatesStepV26 }>(),
);

export const selectCancelDetailsStep = createAction(
  '[V26 Wizard Cancel Details Step] Select Terminate Multi Asset Cancel Details Step',
  props<{ cancelDetailsStep: TerminateMultiAssetCancelDetailsDataV26[] }>(),
);

export const deleteCancelDetailsStep = createAction('[V26 Wizard CancelDetails Step] Delete Terminate Multi Asset CancelDetails Step');

export const exitTerminateMultiAssetWizard = createAction('[V26 TerminateMultiAsset Wizard Page] Exit Terminate Multi Asset Wizard');

export const destroyWizard = createAction('[V26 TerminateMultiAsset Wizard Page] Destroy Wizard');

export const createNewTerminateMultiAsset = createAction(
  '[V26 Wizard Confirmation Step] Create Terminate Multi Asset Information Step',
  props<{ request: CancelAssetServicesRequestV26 }>(),
);

export const createNewTerminateMultiAssetSuccess = createAction(
  '[V26 Wizard Confirmation Step] Create Terminate Multi Asset Information Step Success',
  props<{ response: ActionResponse }>(),
);

export const createNewTerminateMultiAssetFail = createAction(
  '[V26 Wizard Confirmation Step] Create Terminate Multi Asset Information Step Fail',
  props<{ errorMessage: string }>(),
);
